import { render, staticRenderFns } from "./tiempos.vue?vue&type=template&id=2212a462&"
import script from "./tiempos.vue?vue&type=script&lang=js&"
export * from "./tiempos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports